import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Note: In production, move this config to environment variables or load it server-side
const firebaseConfig = {
    apiKey: "AIzaSyCM7_02WvvSW7GplcmKU4Ho9d_shYnWUcg",
    authDomain: "quizacer.firebaseapp.com",
    projectId: "quizacer",
    storageBucket: "quizacer.firebasestorage.app",
    messagingSenderId: "990938611917",
    appId: "1:990938611917:web:0345245ce292fb72c4e984",
    measurementId: "G-JD2SF7Z09E"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
    prompt: 'select_account',
});